// ---- source script: home(1).html ----

(function(){
  'use strict';
  var avatarImgs = Array.prototype.slice.call(document.querySelectorAll('.av img,.rev-av img,.vid-av img'));
  avatarImgs.forEach(function(img){
    var wrap = img.parentElement;
    if(!wrap) return;
    var src = img.currentSrc || img.src;
    if(src){
      wrap.style.backgroundImage = 'url("' + src.replace(/"/g,'%22') + '")';
      wrap.style.backgroundSize = 'cover';
      wrap.style.backgroundPosition = 'center';
      wrap.style.backgroundRepeat = 'no-repeat';
    }
    img.loading = 'eager';
    img.decoding = 'sync';
    img.draggable = false;
    img.addEventListener('error', function(){
      var sourceText = img.getAttribute('alt') || (wrap.closest('.rev-author,.vid-reviewer') ? wrap.closest('.rev-author,.vid-reviewer').innerText : '');
      var initials = (sourceText.match(/[A-Z]/g) || ['B','S']).slice(0,2).join('');
      wrap.setAttribute('data-initials', initials);
      wrap.classList.add('avatar-fallback');
      img.style.display = 'none';
    }, {once:true});
  });
})();


// ---- source script: home(1).html ----

// Scroll Reveal
const obs = new IntersectionObserver(entries=>{
 entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target);}});
},{threshold:0.11,rootMargin:'0px 0px -36px 0px'});
document.querySelectorAll('.reveal').forEach(el=>obs.observe(el));

// FAQ Accordion
document.querySelectorAll('.faq-q').forEach(q=>{
 q.addEventListener('click',()=>{
 const item=q.parentElement;
 const wasOpen=item.classList.contains('open');
 document.querySelectorAll('.faq-item').forEach(i=>i.classList.remove('open'));
 if(!wasOpen) item.classList.add('open');
 });
});

// Smooth scroll
document.querySelectorAll('a[href^="#"]').forEach(a=>{
 a.addEventListener('click',e=>{
 const t=document.querySelector(a.getAttribute('href'));
 if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}
 });
});

// Nav shadow on scroll
window.addEventListener('scroll',()=>{
 document.querySelector('nav').style.boxShadow=
 window.scrollY>18?'0 4px 24px rgba(0,0,0,.12)':'none';
});


// ---- source script: home(1).html ----

(function(){
'use strict';



// NAV SCROLL SHADOW
var nav=document.querySelector('nav');
window.addEventListener('scroll',function(){nav.classList.toggle('scrolled',window.scrollY>20)},{passive:true});

// ANNOUNCEMENT COUNTDOWN
var cdEl=document.getElementById('ann-countdown');
var cdEl2=document.getElementById('ann-countdown2');
if(cdEl){var end=Date.now()+25*60*1000;(function tick(){var r=Math.max(0,end-Date.now()),m=Math.floor(r/60000),s=Math.floor(r%60000/1000),t=(m<10?'0':'')+m+':'+(s<10?'0':'')+s;cdEl.textContent=t;if(cdEl2)cdEl2.textContent=t;if(r>0)setTimeout(tick,1000)})()}

// MOBILE HAMBURGER
var ham=document.getElementById('nav-ham'),drawer=document.getElementById('nav-drawer');
if(ham&&drawer){
 ham.addEventListener('click',function(){ham.classList.toggle('open');drawer.classList.toggle('open');document.body.style.overflow=ham.classList.contains('open')?'hidden':''});
 drawer.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){ham.classList.remove('open');drawer.classList.remove('open');document.body.style.overflow=''})});
}

// STICKY FLOATING CTA
var stickCta=document.getElementById('sticky-cta'),heroEl=document.querySelector('.hero'),footerEl=document.querySelector('.site-footer')||document.querySelector('footer');
if(stickCta&&heroEl){
 function showSticky(){
 var scrollY=window.scrollY,hb=heroEl.getBoundingClientRect().bottom+scrollY,ft=footerEl?(footerEl.getBoundingClientRect().top+scrollY):Infinity;
 stickCta.classList.toggle('show',scrollY>hb*0.55&&scrollY<ft-80);
 }
 window.addEventListener('scroll',showSticky,{passive:true});
}

// LIVE VIEWER COUNT - SYNCED TOP + URGENCY BAR
(function(){
 var viewerEls=Array.prototype.slice.call(document.querySelectorAll('.live-viewers-sync,#live-viewers,#rev-live-viewers'));
 if(!viewerEls.length) return;

 // keep one shared live value for every viewer-count placement
 var vc=parseInt(viewerEls[0].textContent,10);
 if(!isFinite(vc)) vc=143;

 function render(){
  viewerEls.forEach(function(el){
   el.textContent=vc;
  });
 }

 function jit(){
  var d=Math.round((Math.random()-.46)*3);
  vc=Math.max(118,Math.min(192,vc+d));
  render();
  setTimeout(jit,3800+Math.random()*2600);
 }

 render();
 setTimeout(jit,900);
})();

// RIPPLE EFFECT
document.querySelectorAll('.btn-white,.sticky-cta-btn,.nav-btn,.nav-mobile-cta').forEach(function(btn){
 btn.addEventListener('click',function(e){
 var r=document.createElement('span'),rect=btn.getBoundingClientRect(),sz=Math.max(rect.width,rect.height);
 r.className='ripple';r.style.cssText='width:'+sz+'px;height:'+sz+'px;left:'+(e.clientX-rect.left-sz/2)+'px;top:'+(e.clientY-rect.top-sz/2)+'px;position:absolute';
 btn.appendChild(r);setTimeout(function(){r.remove()},700);
 });
});

// INTERSECTION OBSERVER REVEALS
if('IntersectionObserver' in window){
 var ro=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');ro.unobserve(e.target)}})},{threshold:0.1});
 document.querySelectorAll('.reveal').forEach(function(el){ro.observe(el)});
}

})();


// ---- source script: home(1).html ----

(function(){
 var overlay = document.getElementById('popup-overlay');
 var box = document.getElementById('popup-box');
 var closeBtn = document.getElementById('popup-close');
 var dismiss = document.getElementById('popup-dismiss');
 var ctaBtn = document.getElementById('popup-cta');
 var shown = false;

 function showPopup(){
 if(shown) return;
 shown = true;
 clearTimeout(timerID);
 window.removeEventListener('scroll', onScroll);

 overlay.style.display = 'flex';
 requestAnimationFrame(function(){
 requestAnimationFrame(function(){
 overlay.style.opacity = '1';
 box.style.opacity = '1';
 box.style.transform = 'translateY(0) scale(1)';
 });
 });
 }

 function hidePopup(){
 overlay.style.opacity = '0';
 box.style.opacity = '0';
 box.style.transform = 'translateY(24px) scale(.97)';
 setTimeout(function(){ overlay.style.display = 'none'; }, 380);
 }

 // Trigger 1 4 seconds
 var timerID = setTimeout(showPopup, 4000);

 // Trigger 2 50% scroll depth
 function onScroll(){
 var doc = document.documentElement;
 var scrolled = (doc.scrollTop || document.body.scrollTop);
 var total = doc.scrollHeight - doc.clientHeight;
 if(total > 0 && scrolled / total >= 0.5) showPopup();
 }
 window.addEventListener('scroll', onScroll, {passive:true});

 // Close handlers
 closeBtn.addEventListener('click', hidePopup);
 dismiss.addEventListener('click', hidePopup);
 overlay.addEventListener('click', function(e){ if(e.target === overlay) hidePopup(); });
 document.addEventListener('keydown', function(e){ if(e.key === 'Escape') hidePopup(); });

 // Close popup + scroll to products on CTA click
 ctaBtn.addEventListener('click', function(){ hidePopup(); });

 // Hover effect on CTA
 ctaBtn.addEventListener('mouseenter', function(){ this.style.transform='translateY(-2px)'; this.style.boxShadow='0 14px 48px rgba(84,87,212,.55)'; });
 ctaBtn.addEventListener('mouseleave', function(){ this.style.transform=''; this.style.boxShadow='0 8px 32px rgba(84,87,212,.35)'; });
 closeBtn.addEventListener('mouseenter', function(){ this.style.background='rgba(0,0,0,.12)'; });
 closeBtn.addEventListener('mouseleave', function(){ this.style.background='rgba(0,0,0,.06)'; });
})();


// ---- source script: home(1).html ----

(function(){
  if(window.innerWidth >= 1024) return;

  var revGrid = document.querySelector('.reviews-grid');
  if(!revGrid) return;

  var isDown = false;
  var startX = 0;
  var scrollLeft = 0;

  revGrid.addEventListener('mousedown', function(e){
    isDown = true;
    revGrid.classList.add('active');
    startX = e.pageX - revGrid.offsetLeft;
    scrollLeft = revGrid.scrollLeft;
  });

  ['mouseleave','mouseup'].forEach(function(evt){
    revGrid.addEventListener(evt, function(){
      isDown = false;
      revGrid.classList.remove('active');
    });
  });

  revGrid.addEventListener('mousemove', function(e){
    if(!isDown) return;
    e.preventDefault();
    var x = e.pageX - revGrid.offsetLeft;
    revGrid.scrollLeft = scrollLeft - (x - startX) * 1.5;
  });
})();


// ---- source script: home(1).html ----

(function(){
  if(window.innerWidth >= 1024) return;

  var grid  = document.querySelector('.feats-grid');
  var cards = grid ? Array.from(grid.querySelectorAll('.feat-card')) : [];
  var dots  = Array.from(document.querySelectorAll('.feats-dot'));
  if(!grid || !cards.length) return;

  var cur = 0;

  function setActive(idx){
    cur = idx;
    cards.forEach(function(c,i){ c.classList.toggle('fc-active', i===idx); });
    dots.forEach(function(d,i){ d.classList.toggle('active', i===idx); });
  }

  // Set first card active on load
  setActive(0);

  // Update active card based on scroll position
  function onScroll(){
    var center = grid.scrollLeft + grid.offsetWidth / 2;
    var closest = 0, minDist = Infinity;
    cards.forEach(function(c,i){
      var dist = Math.abs((c.offsetLeft + c.offsetWidth/2) - center);
      if(dist < minDist){ minDist = dist; closest = i; }
    });
    if(closest !== cur) setActive(closest);
  }
  grid.addEventListener('scroll', onScroll, {passive:true});

  // Dot tap navigation
  dots.forEach(function(dot, i){
    dot.addEventListener('click', function(){
      cards[i].scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
      setActive(i);
    });
  });

  // Drag support for non-touch
  var isDown = false, startX, startScroll;
  grid.addEventListener('mousedown', function(e){ isDown=true; startX=e.pageX-grid.offsetLeft; startScroll=grid.scrollLeft; });
  grid.addEventListener('mouseleave', function(){ isDown=false; });
  grid.addEventListener('mouseup',   function(){ isDown=false; });
  grid.addEventListener('mousemove', function(e){ if(!isDown) return; e.preventDefault(); grid.scrollLeft = startScroll - (e.pageX - grid.offsetLeft - startX)*1.2; });

})();


// ---- source script: home(1).html ----

(function () {
  'use strict';
  if (window.__booUnifiedCompareVideoPatch__) return;
  window.__booUnifiedCompareVideoPatch__ = true;

  function injectStyles() {
    if (document.getElementById('boo-unified-compare-video-patch-style')) return;

    var style = document.createElement('style');
    style.id = 'boo-unified-compare-video-patch-style';
    style.textContent = [
      '#baSlider{--ba-pos:50%;position:relative!important;touch-action:none!important;-ms-touch-action:none!important;overscroll-behavior:contain!important;-webkit-user-select:none!important;user-select:none!important;-webkit-touch-callout:none!important;}',
      '#baSlider .ba-before,#baSlider .ba-after,#baSlider .ba-handle,#baSlider .ba-label,#baSlider .ba-hint,#baSlider .ba-btn{pointer-events:none!important;}',
      '#baSlider .ba-after{-webkit-clip-path:inset(0 0 0 var(--ba-pos,50%))!important;clip-path:inset(0 0 0 var(--ba-pos,50%))!important;}',
      '#baSlider .ba-handle{left:var(--ba-pos,50%)!important;z-index:40!important;}',
      '#baSlider .ba-hint,#baSlider .ba-label{z-index:45!important;}',
      '#baSlider .ba-range{position:absolute!important;inset:0!important;z-index:50!important;display:block!important;width:100%!important;height:100%!important;min-width:100%!important;min-height:100%!important;margin:0!important;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;opacity:.001!important;cursor:ew-resize!important;pointer-events:auto!important;touch-action:none!important;-ms-touch-action:none!important;-webkit-user-select:none!important;user-select:none!important;-webkit-touch-callout:none!important;-webkit-tap-highlight-color:transparent!important;outline:none!important;-webkit-appearance:none!important;appearance:none!important;}',
      '#baSlider .ba-range::-webkit-slider-runnable-track{width:100%!important;height:100%!important;background:transparent!important;border:0!important;}',
      '#baSlider .ba-range::-webkit-slider-thumb{-webkit-appearance:none!important;appearance:none!important;width:88px!important;height:100vh!important;background:transparent!important;border:0!important;box-shadow:none!important;cursor:ew-resize!important;}',
      '#baSlider .ba-range::-moz-range-track{width:100%!important;height:100%!important;background:transparent!important;border:0!important;}',
      '#baSlider .ba-range::-moz-range-thumb{width:88px!important;height:100vh!important;background:transparent!important;border:0!important;box-shadow:none!important;cursor:ew-resize!important;}',
      '#baSlider.is-dragging .ba-btn{transform:translate(-50%,-50%) scale(1.08)!important;}',
      '.vid-player-card{cursor:pointer!important;touch-action:manipulation!important;-webkit-tap-highlight-color:transparent!important;}',
      '.vid-player-card video{display:block!important;width:100%!important;object-fit:cover!important;pointer-events:none!important;}',
      '.vid-player-card .vp-overlay,.vid-player-card .vid-info,.vid-player-card .vp-sound-badge{pointer-events:none!important;}',
      '.vid-player-card.is-playing .vp-overlay{opacity:0!important;visibility:hidden!important;}',
      '.vid-player-card .vp-sound-badge[data-label]::before{content:attr(data-label)!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function clamp(num, min, max) {
    num = Number(num);
    if (!isFinite(num)) num = 50;
    return Math.max(min, Math.min(max, num));
  }

  function replaceWithClone(node) {
    if (!node || !node.parentNode) return node;
    var clone = node.cloneNode(true);
    node.parentNode.replaceChild(clone, node);
    return clone;
  }

  function xFromEvent(e) {
    if (!e) return null;
    if (e.touches && e.touches.length) return e.touches[0].clientX;
    if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
    if (typeof e.clientX === 'number') return e.clientX;
    return null;
  }

  function stopEvent(e) {
    if (!e) return;
    if (e.cancelable) e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
  }

  function initCompareSlider() {
    var originalSlider = document.getElementById('baSlider');
    if (!originalSlider || originalSlider.__booUnifiedCompareReady) return;

    var slider = replaceWithClone(originalSlider);
    slider.__booUnifiedCompareReady = true;
    var after = document.getElementById('baAfter') || slider.querySelector('.ba-after');
    var handle = document.getElementById('baHandle') || slider.querySelector('.ba-handle');
    var range = document.getElementById('baRange') || slider.querySelector('.ba-range');
    var hint = document.getElementById('baHint') || slider.querySelector('.ba-hint');

    if (!after || !handle) return;

    Array.prototype.slice.call(
      slider.querySelectorAll('.ba-touch-layer,.ba-hitbox')
    ).forEach(function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });

    if (!range) {
      range = document.createElement('input');
      range.id = 'baRange';
      slider.appendChild(range);
    }

    range.classList.add('ba-range');
    range.type = 'range';
    range.min = '0';
    range.max = '100';
    range.step = '0.1';
    range.value = range.value || '50';
    range.setAttribute('aria-label', 'Drag to compare before and after pillow photos');

    var value = clamp(range.value || 50, 0, 100);
    var dragging = false;

    function apply(nextValue, fromUser) {
      value = clamp(nextValue, 0, 100);
      var pos = value.toFixed(2) + '%';

      slider.style.setProperty('--ba-pos', pos);
      after.style.webkitClipPath = 'inset(0 0 0 ' + pos + ')';
      after.style.clipPath = 'inset(0 0 0 ' + pos + ')';
      handle.style.left = pos;

      range.value = String(value);
      range.setAttribute('aria-valuenow', String(Math.round(value)));

      if (hint && fromUser) hint.style.opacity = '0';
    }

    function applyFromEvent(e, fromUser) {
      var clientX = xFromEvent(e);
      if (clientX === null) return;

      var rect = slider.getBoundingClientRect();
      if (!rect || !rect.width) return;

      var pct = ((clientX - rect.left) / rect.width) * 100;
      apply(pct, fromUser);
    }

    function startDrag(e) {
      dragging = true;
      slider.classList.add('is-dragging');

      if (e && e.pointerId != null && range.setPointerCapture) {
        try { range.setPointerCapture(e.pointerId); } catch (err) {}
      }

      applyFromEvent(e, true);
      if (e && e.cancelable) e.preventDefault();
    }

    function moveDrag(e) {
      if (!dragging) return;
      applyFromEvent(e, true);
      if (e && e.cancelable) e.preventDefault();
    }

    function endDrag() {
      dragging = false;
      slider.classList.remove('is-dragging');
    }

    range.addEventListener('input', function () {
      apply(range.value, true);
    }, { passive: true });

    range.addEventListener('change', function () {
      apply(range.value, true);
    }, { passive: true });

    if (window.PointerEvent) {
      range.addEventListener('pointerdown', startDrag, { passive: false });
      window.addEventListener('pointermove', moveDrag, { passive: false });
      window.addEventListener('pointerup', endDrag, { passive: true });
      window.addEventListener('pointercancel', endDrag, { passive: true });
    } else {
      range.addEventListener('touchstart', startDrag, { passive: false });
      window.addEventListener('touchmove', moveDrag, { passive: false });
      window.addEventListener('touchend', endDrag, { passive: true });
      window.addEventListener('touchcancel', endDrag, { passive: true });

      range.addEventListener('mousedown', startDrag, false);
      window.addEventListener('mousemove', moveDrag, false);
      window.addEventListener('mouseup', endDrag, false);
    }

    slider.addEventListener('click', function (e) {
      if (e.target === range) return;
      applyFromEvent(e, true);
    }, true);

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        apply(value, false);
      });
      ro.observe(slider);
    } else {
      window.addEventListener('resize', function () {
        apply(value, false);
      }, { passive: true });

      window.addEventListener('orientationchange', function () {
        window.setTimeout(function () {
          apply(value, false);
        }, 250);
      }, { passive: true });
    }

    apply(value, false);
  }

  function initVideoCards() {
    var originalGrid = document.getElementById('vidGrid');
    if (!originalGrid || originalGrid.__booUnifiedVideoReady) return;

    var grid = replaceWithClone(originalGrid);
    grid.__booUnifiedVideoReady = true;
    var dotsWrapper = document.getElementById('vidDots');
    if (dotsWrapper && !dotsWrapper.__booUnifiedDotsReady) {
      dotsWrapper = replaceWithClone(dotsWrapper);
      dotsWrapper.__booUnifiedDotsReady = true;
    }

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.vid-player-card'));
    var dotEls = dotsWrapper
      ? Array.prototype.slice.call(dotsWrapper.querySelectorAll('.vid-dot'))
      : [];

    function setBadge(card, text) {
      var badge = card.querySelector('.vp-sound-badge');
      if (!badge) return;
      badge.style.display = 'flex';
      badge.setAttribute('data-label', text || '');
    }

    function setCardState(card, state) {
      var overlay = card.querySelector('.vp-overlay');

      card.classList.toggle('is-playing', state === 'playing' || state === 'muted');
      card.setAttribute(
        'aria-pressed',
        (state === 'playing' || state === 'muted') ? 'true' : 'false'
      );

      if (overlay) {
        if (state === 'playing' || state === 'muted') overlay.classList.add('hidden');
        else overlay.classList.remove('hidden');
      }

      if (state === 'playing') setBadge(card, '🔊 PLAYING');
      else if (state === 'muted') setBadge(card, '🔇 PLAYING MUTED');
      else if (state === 'loading') setBadge(card, '⏳ LOADING');
      else if (state === 'error') setBadge(card, '⚠️ LOAD FAILED');
      else setBadge(card, '▶ TAP TO PLAY');
    }

    function prepVideo(video) {
      if (!video) return;

      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('x5-playsinline', '');
      video.setAttribute('x5-video-player-type', 'h5-page');
      video.setAttribute('x5-video-player-fullscreen', 'false');
      video.setAttribute(
        'controlsList',
        'nodownload nofullscreen noremoteplayback noplaybackrate'
      );
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute('disableremoteplayback', '');

      video.removeAttribute('controls');
      video.removeAttribute('autoplay');
      video.removeAttribute('loop');

      video.controls = false;
      video.playsInline = true;
      video.preload = 'metadata';
      video.defaultMuted = true;
      video.muted = true;
      video.style.pointerEvents = 'none';

      try { video.disablePictureInPicture = true; } catch (err) {}
      try { video.disableRemotePlayback = true; } catch (err) {}

      var source = video.getAttribute('src') || video.getAttribute('data-src');
      if (source && !video.getAttribute('src')) {
        video.setAttribute('src', source);
      }

      try { video.load(); } catch (err) {}

      video.addEventListener('webkitbeginfullscreen', function () {
        try { video.webkitExitFullscreen(); } catch (err) {}
      }, true);
    }

    function loadReady(video, timeoutMs) {
      return new Promise(function (resolve, reject) {
        if (!video) {
          reject(new Error('missing video'));
          return;
        }

        if ((video.currentSrc && video.currentSrc.length) && video.readyState >= 1) {
          resolve();
          return;
        }

        var settled = false;
        var timer = window.setTimeout(function () {
          if (settled) return;
          settled = true;
          cleanup();

          if ((video.currentSrc && video.currentSrc.length) || video.readyState >= 1) {
            resolve();
          } else {
            reject(new Error('timeout'));
          }
        }, timeoutMs || 7000);

        function cleanup() {
          window.clearTimeout(timer);
          video.removeEventListener('loadedmetadata', onReady);
          video.removeEventListener('canplay', onReady);
          video.removeEventListener('loadeddata', onReady);
          video.removeEventListener('error', onError);
        }

        function onReady() {
          if (settled) return;
          settled = true;
          cleanup();
          resolve();
        }

        function onError() {
          if (settled) return;
          settled = true;
          cleanup();
          reject(video.error || new Error('media error'));
        }

        video.addEventListener('loadedmetadata', onReady);
        video.addEventListener('canplay', onReady);
        video.addEventListener('loadeddata', onReady);
        video.addEventListener('error', onError);

        try { video.load(); } catch (err) {}
      });
    }

    function playPromise(video) {
      try {
        var result = video.play();
        if (result && typeof result.then === 'function') return result;
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    }

    function pauseOthers(currentCard) {
      cards.forEach(function (card) {
        if (card === currentCard) return;

        var otherVideo = card.querySelector('video');
        if (!otherVideo) return;

        try { otherVideo.pause(); } catch (err) {}
        setCardState(card, 'idle');
      });
    }

    function toggleCard(card) {
      var video = card.querySelector('video');
      if (!video) return;

      if (!video.paused && !video.ended) {
        try { video.pause(); } catch (err) {}
        setCardState(card, 'idle');
        return;
      }

      pauseOthers(card);
      setCardState(card, 'loading');

      loadReady(video, 7000)
        .catch(function () {
          return Promise.resolve();
        })
        .then(function () {
          video.defaultMuted = false;
          video.muted = false;
          video.volume = 1;

          return playPromise(video).then(function () {
            setCardState(card, 'playing');
          }).catch(function () {
            video.defaultMuted = true;
            video.muted = true;
            video.volume = 0;

            return playPromise(video).then(function () {
              setCardState(card, 'muted');
            });
          });
        })
        .catch(function () {
          setCardState(card, 'error');
        });
    }

    function bindCard(card) {
      var video = card.querySelector('video');
      if (!video) return;

      prepVideo(video);
      setCardState(card, 'idle');

      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', 'Play customer review video');
      card.setAttribute('aria-pressed', 'false');

      var startX = 0;
      var startY = 0;
      var moved = false;
      var suppressClickUntil = 0;

      function pointFrom(e) {
        var x = xFromEvent(e);
        var y = null;

        if (e && e.touches && e.touches.length) y = e.touches[0].clientY;
        else if (e && e.changedTouches && e.changedTouches.length) y = e.changedTouches[0].clientY;
        else if (e && typeof e.clientY === 'number') y = e.clientY;

        return { x: x, y: y };
      }

      function start(e) {
        var p = pointFrom(e);
        startX = p.x || 0;
        startY = p.y || 0;
        moved = false;
      }

      function move(e) {
        var p = pointFrom(e);
        if (p.x === null || p.y === null) return;

        if (Math.abs(p.x - startX) > 12 || Math.abs(p.y - startY) > 12) {
          moved = true;
        }
      }

      function activate(e) {
        if (moved) return;
        suppressClickUntil = Date.now() + 500;
        stopEvent(e);
        toggleCard(card);
      }

      if (window.PointerEvent) {
        card.addEventListener('pointerdown', start, { capture: true, passive: true });
        card.addEventListener('pointermove', move, { capture: true, passive: true });
        card.addEventListener('pointerup', activate, { capture: true, passive: false });
      } else {
        card.addEventListener('touchstart', start, { capture: true, passive: true });
        card.addEventListener('touchmove', move, { capture: true, passive: true });
        card.addEventListener('touchend', activate, { capture: true, passive: false });
      }

      card.addEventListener('click', function (e) {
        if (Date.now() < suppressClickUntil) {
          stopEvent(e);
          return;
        }
        activate(e);
      }, { capture: true, passive: false });

      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') activate(e);
      }, { capture: true, passive: false });

      video.addEventListener('ended', function () {
        try { video.currentTime = 0; } catch (err) {}
        setCardState(card, 'idle');
      });

      video.addEventListener('error', function () {
        setCardState(card, 'error');
      });
    }

    function syncDots() {
      if (!dotEls.length) return;

      var center = grid.scrollLeft + (grid.clientWidth / 2);
      var closest = 0;
      var minDistance = Infinity;

      cards.forEach(function (card, index) {
        var cardCenter = card.offsetLeft + (card.offsetWidth / 2);
        var distance = Math.abs(cardCenter - center);

        if (distance < minDistance) {
          minDistance = distance;
          closest = index;
        }
      });

      dotEls.forEach(function (dot, index) {
        dot.classList.toggle('active', index === closest);
      });
    }

    cards.forEach(bindCard);

    if (dotEls.length) {
      dotEls.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          if (cards[index]) {
            cards[index].scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            });
          }
          window.setTimeout(syncDots, 200);
        });
      });

      grid.addEventListener('scroll', syncDots, { passive: true });
      syncDots();
    }
  }

  function init() {
    injectStyles();
    initCompareSlider();
    initVideoCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('load', init, { once: true });
})();


// ---- source script: home(1).html ----

(function(){
  var home = (window.BOO_ROUTES && window.BOO_ROUTES.home) || '/';
  var product = (window.BOO_ROUTES && window.BOO_ROUTES.product) || '/collections/all';
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('a').forEach(function(a){
      var txt = (a.textContent || '').trim().toLowerCase();
      var aria = (a.getAttribute('aria-label') || '').toLowerCase();
      if (txt === 'home' || aria.indexOf('home') !== -1 || a.classList.contains('product-logo') || a.classList.contains('ig-footer-logo')) {
        a.setAttribute('href', home);
      }
      if ((a.getAttribute('href') || '') === '#products') {
        a.setAttribute('href', product);
      }
    });
  });
})();

